import { DEFAULT_LAYOUT_CONFIG } from 'app/layouts/DefaultLayout';
import _ from 'lodash';

import { DEFAULT_THEME_MODE } from 'constants/themes';
import { getExtendedThemesConfigs } from 'utils/theme';

import { SETTINGS_ACTION_TYPE } from 'store/global/actions';

const initialSettings = {
  layout: {
    config: DEFAULT_LAYOUT_CONFIG,
  },
  themeMode: DEFAULT_THEME_MODE,
};

const initialThemes = getExtendedThemesConfigs();

const initialState = {
  initial: initialSettings,
  default: initialSettings,
  current: initialSettings,
  themes: initialThemes,
  layoutState: {
    sidebar: {
      isOpen: false,
    },
  },
};

const settingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SETTINGS_ACTION_TYPE.SET_SETTINGS: {
      const newSettings = _.merge(
        {},
        state.current,
        { layout: { config: DEFAULT_LAYOUT_CONFIG } },
        payload,
      );

      return {
        ...state,
        current: newSettings,
      };
    }

    case SETTINGS_ACTION_TYPE.SET_INITIAL_SETTINGS: {
      return _.merge({}, initialState);
    }

    case SETTINGS_ACTION_TYPE.SET_DEFAULT_SETTINGS: {
      const newSettings = _.merge(
        {},
        state.default,
        { layout: { config: DEFAULT_LAYOUT_CONFIG } },
        payload,
      );

      return {
        ...state,
        default: newSettings,
        current: newSettings,
      };
    }

    case SETTINGS_ACTION_TYPE.SET_IS_SIDEBAR_OPEN: {
      return {
        ...state,
        layoutState: {
          ...state.layoutState,
          sidebar: {
            ...state.layoutState?.sidebar,
            isOpen: payload,
          },
        },
      };
    }

    case SETTINGS_ACTION_TYPE.RESET_DEFAULT_SETTINGS: {
      return {
        ...state,
        current: state.default,
      };
    }

    default: {
      return state;
    }
  }
};

export default settingsReducer;
